module.exports = __webpack_public_path__ + "static/media/trail-running-shoe.6912bd71.svg";